import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../utils/LanguageContext';

const Footer = () => {
  const { language } = useTranslation();
  const [footerData, setFooterData] = useState(null);

  useEffect(() => {
    const loadFooterData = async () => {
      try {
        let response = await fetch(`/data_copy/type=data_course_master/language=${language}/footer__${language}.json`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
       
        if (!response.ok && language !== 'en') {
          response = await fetch('/data_copy/type=data_course_master/language=${language}/footer__en.json', {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          });
        }

        if (response.ok) {
          const data = await response.json();
          const mainFooter = data.find(item => item.name_normed === 'footer_main');
          setFooterData(mainFooter);
        } else {
          console.error('Failed to load footer data');
        }
      } catch (error) {
        console.error('Error loading footer data:', error);
      }
    };

    loadFooterData();
  }, [language]);

  return (
    <footer className="bg-white shadow-sm mt-8">
      <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
        {footerData && (
          <p
            className="text-center text-sm text-gray-500"
            dangerouslySetInnerHTML={{ __html: footerData.value }}
          />
        )}
      </div>
    </footer>
  );
};

export default Footer;